import { useContactsByEmail } from 'modules/mailing/email-statistics/hooks/use-contacts-by-email'
import { StatisticsFilterInterface } from 'modules/mailing/email-statistics/types/email-statistics-filter-interface'
import React, { useEffect, useRef, useState } from 'react'
import { FormSelectAsyncMultiple } from 'shared/components/form-select/form-select-async-multiple'

interface EmailStatisticsEmailFilterProps {
  contacts: StatisticsFilterInterface['contacts']
  onChangeContacts: (value: StatisticsFilterInterface['contacts']) => void
}
const EmailStatisticsEmailFilter = ({
  contacts,
  onChangeContacts,
}: EmailStatisticsEmailFilterProps) => {
  const [search, setSearch] = useState('')
  const [email, setEmail] = useState('')
  const searchTimerRef = useRef<NodeJS.Timeout | null>(null)
  const [isTyping, setIsTyping] = useState(false)

  const { contactsFilter, abort, isValidating } = useContactsByEmail(email)
  const data = contactsFilter?.items.map(contact => ({ id: contact.id, caption: contact.email }))

  useEffect(() => {
    if (search) {
      setIsTyping(true)
    }
    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current)
      abort()
    }
    searchTimerRef.current = setTimeout(() => {
      setEmail(search)
      setIsTyping(false)
    }, 1500)
  }, [abort, search])

  const isFetching = (isValidating && !contactsFilter) || isTyping

  return (
    <FormSelectAsyncMultiple
      search={search}
      onSearchChange={setSearch}
      staticData={contacts}
      data={isFetching ? undefined : data}
      onChange={contactIds => {
        const contacts = data?.filter(el => contactIds.includes(el.id))
        onChangeContacts(contacts ?? [])
      }}
      value={contacts.map(el => el.id)}
      isFetching={isFetching}
      moreItems={contactsFilter?.hasMore ? 100 : undefined}
      className={'w-[300px]'}
    />
  )
}

export default EmailStatisticsEmailFilter
